import MenuItem from '@mui/material/MenuItem';
import { ReactNode } from 'react';
import { ItemWithLabel } from '../utils';
import TextField, { TextFieldProps } from './TextField';

export default function SelectField({
  options,
  disableScrollLock = true,
  displayEmpty = false,
  renderValue,
  ...rest
}: SelectFieldProps) {
  return (
    <TextField
      clearSx={{ position: 'absolute', right: 20 }}
      InputLabelProps={{
        shrink: displayEmpty || undefined,
      }}
      select
      SelectProps={{
        displayEmpty,
        renderValue,
        MenuProps: { disableScrollLock },
      }}
      {...rest}
    >
      {options?.map((option) => (
        <MenuItem
          disabled={option.disabled}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export type SelectFieldProps = {
  disableScrollLock?: boolean;
  displayEmpty?: boolean;
  options?: ItemWithLabel[];
  renderValue?: (val: unknown) => ReactNode;
} & TextFieldProps;
